<img class="loader" src="/assets/svg/loader.svg" alt="" />
<!-- <img class="newLoader" *ngIf="user.isPremium" src="/assets/svg/loader-new.svg" alt="" /> -->
